import styled from 'styled-components';
import {Dialog, DialogActions, DialogContent, DialogTitle, TextField} from '@mui/material';
import { media } from '../../theme/breakpoints';

export const StyledDialog = styled(Dialog)`
    .MuiPaper-root {
        width: 100%;
        min-width: unset;

        ${media.sm} {
            min-width: 400px;
            width: 400px;
        }
    }
`;

export const StyledDialogTitle = styled(DialogTitle)`
    padding: 16px 24px;

    h2 {
        font-size: 1.25rem;
        font-weight: 600;
    }
`;

export const StyledDialogContent = styled(DialogContent)`
    padding: 32px !important;
`;

export const StyledDialogActions = styled(DialogActions)`
    padding-top: 8px;
    padding-left: 24px;
    padding-bottom: 20px !important;
    padding-right: 20px !important;
    justify-content: flex-end;
`;

export const InputField = styled(TextField)`
`;

export const ErrorText = styled.div`
    color: #d32f2f;
    margin-top: 0.5rem;
    font-size: 0.875rem;
`;
